import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { Pagination as Paginator } from 'reactstrap';
import Page from './_page';

class Pagination extends React.Component {
  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
    this.getTotalPages = this.getTotalPages.bind(this);
    this.getPages = this.getPages.bind(this);
  }

  getTotalPages() {
    const { itemsPerPage, totalItems } = this.props;

    return Math.ceil(totalItems / itemsPerPage);
  }

  getPages(totalPages) {
    const { activePage } = this.props;
    const pages = [1];
    for (let i = 2; i <= totalPages; i++) {
      if (activePage - 3 < i && activePage + 3 > i) {
        pages.push(i);
      } else if (i === 2 || i === totalPages - 1) {
        pages.push('...');
      }
    }
    if (pages[pages.length - 1] !== totalPages) {
      pages.push(totalPages);
    }

    return pages;
  }

  handleClick(targetPage) {
    if (this.getTotalPages() < targetPage) {
      window.console.log('Page does not exist');
    } else {
      const { onChange } = this.props;
      onChange(targetPage);
    }
  }

  render() {
    const { intl, activePage, prevPageText, nextPageText } = this.props;
    const totalPages = this.getTotalPages();
    if (totalPages < 2) {
      return null;
    }

    const pages = this.getPages(totalPages);

    return (
      <Paginator key={activePage}>
        <Page
          previous
          active={activePage === 1}
          text={prevPageText || intl.formatMessage({ id: 'overall_pagination_prev' })}
          handleClick={() => this.handleClick(activePage - 1)}
        />{pages.map((pageNumber, i) => (
          <Page
            // eslint-disable-next-line
            key={pageNumber === '...' ? (i === 1 ? 'afterfirst' : 'prelast') : pageNumber}
            active={activePage === pageNumber}
            text={pageNumber}
            handleClick={() => this.handleClick(pageNumber)}
          />))}
        <Page
          next
          active={activePage === totalPages}
          text={nextPageText || intl.formatMessage({ id: 'overall_pagination_next' })}
          handleClick={() => this.handleClick(activePage + 1)}
        />
      </Paginator>
    );
  }
}

Pagination.propTypes = {
  intl: PropTypes.objectOf(PropTypes.any).isRequired,
  activePage: PropTypes.number.isRequired,
  itemsPerPage: PropTypes.number.isRequired,
  totalItems: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  prevPageText: PropTypes.string,
  nextPageText: PropTypes.string,
};

export default injectIntl(Pagination);



// WEBPACK FOOTER //
// ./src/components/_Pagination/index.js